
import { Component, Vue } from 'vue-property-decorator';

@Component({})
export default class ShippingIcon extends Vue {}
